module.exports = "https://web-assets.ifttt.com/packs/media/icons/moon-1a6e9b79.png";